import { configureGtag, trackEvent as trackEventWithGtag } from '../services/gtag/gtag.js';
import { trackEventWithGtm } from '../services/gtm/gtm.js';
import { configureMimir, getMimir, trackEvent as trackEventWithMimir, } from '../services/mimir/mimir.js';
export const configureWebTracking = (options) => {
    configureMimir({
        sessionId: options.sessionId,
        userProperties: options.userProperties,
    });
    configureGtag({
        trackingId: options.gtagId,
        userId: options.userId,
        userProperties: options.userProperties,
        consent: options.consent,
    });
};
export const trackWebEvent = (event) => {
    if (getMimir() && event.isPrivacyFriendly) {
        trackEventWithMimir(event);
    }
    // Also track privacy-friendly events with GTAG, unless marked otherwise,
    // since GTAG is only available when analytical cookies are accepted.
    if (!event.excludeFromGA) {
        trackEventWithGtag(event);
    }
    trackEventWithGtm(event);
};
//# sourceMappingURL=webTracking.js.map